export const DEFAULT_GRID_ACTION_COLLAPSE_TYPE = 'action-collapse';
export const DEFAULT_GRID_ACTION_REMOVE_TYPE = 'action-remove';
